/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../constants';

const IDS = {
  DMI_LABEL: 'footerMessages.dmiLabel',
  HELMET_COLORADO_PAGETITLE: 'footerMessages.helmet.colorado.pageTitle',
  HELMET_CONNECTICUT_PAGETITLE: 'footerMessages.helmet.connecticut.pageTitle',
  HELMET_ELECTRONICCOMMUNICATIONS_PAGETITLE: 'footerMessages.helmet.electronicCommunications.pageTitle',
  HELMET_ESTATEMENT_PAGETITLE: 'footerMessages.helmet.eStatement.pageTitle',
  HELMET_FORECLOSUREALTERNATIVES_PAGETITLE: 'footerMessages.helmet.foreclosureAlternatives.pageTitle',
  HELMET_FORECLOSUREPREVENTION_PAGETITLE: 'footerMessages.helmet.foreclosurePrevention.pageTitle',
  HELMET_ILLINOIS_PAGETITLE: 'footerMessages.helmet.illinois.pageTitle',
  HELMET_IOWA_PAGETITLE: 'footerMessages.helmet.iowa.pageTitle',
  HELMET_NEWYORK_PAGETITLE: 'footerMessages.helmet.newYork.pageTitle',
  HELMET_NYDISCLOSURE_PAGETITLE: 'footerMessages.helmet.nyDisclosure.pageTitle',
  HELMET_PRIVACYPOLICY_PAGETITLE: 'footerMessages.helmet.privacyPolicy.pageTitle',
  HELMET_SECTIONTITLE: 'footerMessages.helmet.sectionTitle',
  HELMET_TERMS_PAGETITLE: 'footerMessages.helmet.terms.pageTitle',
  HELMET_TEXASDISCLOSURE_PAGETITLE: 'footerMessages.helmet.texasDisclosure.pageTitle',
  HELMET_WASHINGTON_PAGETITLE: 'footerMessages.helmet.washington.pageTitle',
};

const enMessages = {
  [IDS.DMI_LABEL]: 'Dovenmuehle Mortgage, Inc.',
  [IDS.HELMET_COLORADO_PAGETITLE]: 'Homeowner Resource Hotlines Colorado',
  [IDS.HELMET_CONNECTICUT_PAGETITLE]: 'Homeowner Resource Hotlines Connecticut',
  [IDS.HELMET_ELECTRONICCOMMUNICATIONS_PAGETITLE]: 'Electronic Communications Policy',
  [IDS.HELMET_ESTATEMENT_PAGETITLE]: 'E-Statements Policy',
  [IDS.HELMET_FORECLOSUREALTERNATIVES_PAGETITLE]: 'Foreclosure Alternatives',
  [IDS.HELMET_FORECLOSUREPREVENTION_PAGETITLE]: 'Foreclosure Prevention',
  [IDS.HELMET_ILLINOIS_PAGETITLE]: 'Homeowner Resource Hotlines Illinois',
  [IDS.HELMET_IOWA_PAGETITLE]: 'Homeowner Resource Hotlines Iowa',
  [IDS.HELMET_NEWYORK_PAGETITLE]: 'Homeowner Resource Hotlines New York',
  [IDS.HELMET_NYDISCLOSURE_PAGETITLE]: 'New York Disclosure',
  [IDS.HELMET_PRIVACYPOLICY_PAGETITLE]: 'Privacy Policy',
  [IDS.HELMET_SECTIONTITLE]: 'Disclosures & Hotlines',
  [IDS.HELMET_TERMS_PAGETITLE]: 'Terms of Use',
  [IDS.HELMET_TEXASDISCLOSURE_PAGETITLE]: 'Texas Disclosure',
  [IDS.HELMET_WASHINGTON_PAGETITLE]: 'Homeowner Resource Hotlines Washington',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.DMI_LABEL]: 'DMI',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
